import { Component, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Observable, empty } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ErrorMessageComponent } from '../error-message/error-message.component'
import { SingleSignOnService } from '../single-sign-on.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup

  @ViewChild(ErrorMessageComponent, { static: true })
  public errorMessageComponent: ErrorMessageComponent

  public constructor(
    private _formBuilder: FormBuilder,
    private _singleSignOnService: SingleSignOnService,
  ) {}

  public ngOnInit() {
    this.loginForm = this._formBuilder.group({ email: null, password: null })
  }

  public onSubmit(user: object) {
    this._singleSignOnService.login(user)
      .pipe(catchError(this._onLoginFailure()))
      .subscribe()
  }

  public resetPassword() {
    this._singleSignOnService.resetPassword()
  }

  private _onLoginFailure() {
    return (error: any): Observable<any> => {
      if (error.status === 401) {
        this.errorMessageComponent.show('Incorrect username or password. Try again, or reset below.')
      } else {
        this.errorMessageComponent.showDefault()
      }

      return empty()
    }
  }
}
